import React, { Component } from 'react';
import { reduxForm, Field } from 'redux-form';
import ReactTable from 'react-table';
import { Grid, Form, Checkbox } from 'semantic-ui-react';
import moment from 'moment';
import * as _ from 'lodash';

import { FieldEnum } from 'Common/FieldEnum';
import * as constants from 'Common/Constants';
import { DatePickerField, Radio } from 'Common/SemanticWrapper';
import { SiteComponent } from 'Common/SiteComponent';
import { TRANSACTION_HISTORY_BY_STUDENT_FORM_NAME } from 'Common/FormEnum';
import { TitledCard } from 'Components';

class TransactionHistoryByStudent extends Component {
  state = {
    siteData: '',
    pageNumberValue: 1,
    siteIdValue: '',
    pageSizeValue: 5,
    firstNameValue: '',
    lastNameValue: '',
    filterValues: [],
    sortValues: [],
    siteChange: false,
    studentId: '',
    showWithDrawnValue: false,
    showDeleted: false,
  };

  dataPopulation = (
    page = this.state.pageNumberValue,
    pageSize = this.state.pageSizeValue,
    siteId = this.state.siteIdValue,
    filters = this.state.filterValues,
    sorts = this.state.sortValues,
    withdrawn = this.state.showWithDrawnValue,
    deleted = this.state.showDeleted
  ) => {
    let changedPage = {
      PageNumber: page,
      PageSize: pageSize,
      SiteId: siteId,
      Filter: filters,
      SortColumn: sorts,
      ShowWithDrawn: withdrawn,
      ShowDeleted: deleted,
    };
    this.props.getStudentsData(changedPage);
  };

  updateSiteChange = data => {
    this.dataPopulation(
      undefined,
      undefined,
      data,
      undefined,
      undefined,
      undefined,
      undefined
    );
    this.setState({
      siteChange: true,
      siteIdValue: data,
      studentId: '',
    });
  };

  // update the checkbox when filters toggle
  updateFilterCheckBox = status => {
    if (
      (this.props.data &&
        this.props.data.Result &&
        this.props.data.Result.length > 0) ||
      this.state.siteChange
    ) {
      let selectedOption = _.filter(this.props.data.Result, {
        IdSeed: this.state.studentId,
        StatusCurrent: status,
      });
      if (selectedOption.length > 0) {
        this.setState({ studentId: '' });
      }
    }
  };

  updateWithDrawn = (e, data) => {
    this.setState({ showWithDrawnValue: data.checked }, () => {
      if (this.state.showWithDrawnValue === false) {
        this.updateFilterCheckBox('5');
      }
    });
    if (
      (this.props.data &&
        this.props.data.Result &&
        this.props.data.Result.length > 0) ||
      this.state.siteChange
    ) {
      this.dataPopulation(
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        data.checked,
        undefined
      );
    }
  };

  updateShowDeleted = (e, data) => {
    this.setState({ showDeleted: data.checked }, () => {
      if (this.state.showDeleted === false) {
        this.updateFilterCheckBox('0');
      }
    });
    if (
      (this.props.data &&
        this.props.data.Result &&
        this.props.data.Result.length > 0) ||
      this.state.siteChange
    ) {
      this.dataPopulation(
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        data.checked
      );
    }
  };

  viewReportByStudent = data => {
    let finalObject = {
      IdSeed: this.state.studentId,
      FromDate: data.values.fromDate,
      ToDate: data.values.toDate,
    };
    this.props.viewStudentReport(finalObject);
  };

  toggleStudentCheckbox = value => {
    this.props.change(FieldEnum.IdSeed, value.IdSeed);
    this.setState({ studentId: value.IdSeed });
  };

  isTimeToFetch(filters, sorts, pageNumberValue, pageSizeValue) {
    if (moment().isAfter(moment(this.state.lastKeyAt).add(1, 's'))) {
      this.timer = null;
      this.setState({ lastKeyAt: null });
      this.dataPopulation(
        pageNumberValue,
        pageSizeValue,
        undefined,
        filters,
        sorts,
        undefined,
        undefined
      );
    }
  }

  fetchData = state => {
    clearInterval(this.timer);
    if (this.state.siteChange) {
      this.timer = null;
      let filters = [];
      let sorts = [];
      if (state.filtered && state.filtered.length > 0) {
        state.filtered.map((filterValue, i) => {
          filters.push({
            FilterName: filterValue.id,
            FilterValue: filterValue.value,
          });
          return null;
        });
      }
      if (state.sorted && state.sorted.length > 0) {
        state.sorted.map((sortValue, i) => {
          sorts.push({
            SortName: sortValue.id,
            SortDirection: sortValue.desc ? 'desc' : 'asc',
          });
          return null;
        });
      }

      this.setState(
        {
          lastKeyAt: moment(),
          filterValues: filters,
          sortValues: sorts,
          pageNumberValue: state.page + 1,
          pageSizeValue: state.pageSize,
          loading: true,
        },
        () => {
          this.timer = setInterval(() => {
            this.isTimeToFetch(
              this.state.filterValues,
              this.state.sortValues,
              this.state.pageNumberValue,
              this.state.pageSizeValue
            );
          }, 200);
        }
      );
    }
  };

  colorChange = rowInfo => {
    if (rowInfo && rowInfo.original && rowInfo.original.StatusCurrent === '5') {
      return 'red';
    } else if (
      rowInfo &&
      rowInfo.original &&
      rowInfo.original.StatusCurrent === '0'
    ) {
      return 'blue';
    } else {
      return '';
    }
  };

  render() {
    const { gridLoading, data } = this.props;

    return (
      <Form>
        <TitledCard title={'Report Parameters'}>
          <Grid columns={3} style={{ paddingBottom: '10px' }}>
            <Grid.Row>
              <Grid.Column>
                <SiteComponent
                  name={FieldEnum.PrimarySiteId}
                  onChange={this.updateSiteChange}
                  isForm={true}
                  {...this.props}
                />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row columns={4}>
              <Grid.Column>
                <Field
                  name={FieldEnum.FromDate}
                  component={DatePickerField}
                  type="text"
                  label="From"
                  openToDate={moment().add(-1, 'days')}
                />
              </Grid.Column>
              <Grid.Column>
                <Field
                  name={FieldEnum.ToDate}
                  component={DatePickerField}
                  type="text"
                  label="To"
                  openToDate={moment()}
                />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row columns={4}>
              <Grid.Column>
                <Checkbox
                  label="Show Withdrawn"
                  toggle
                  onChange={this.updateWithDrawn}
                  disabled={gridLoading}
                />
              </Grid.Column>
              <Grid.Column width="5">
                <Checkbox
                  label="Show Deleted"
                  toggle
                  onChange={this.updateShowDeleted}
                  disabled={gridLoading}
                />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row style={{ paddingBottom: '0px', paddingTop: '0px' }}>
              <Grid.Column>
                <div className="field">
                  <label>SORT BY</label>
                </div>
              </Grid.Column>
            </Grid.Row>
            <Grid.Row columns={4} style={{ paddingTop: '0px' }}>
              <Grid.Column>
                <Field
                  name={FieldEnum.SortBy}
                  component={Radio}
                  label={'Effective Date/Time'}
                  myValue="1"
                />
              </Grid.Column>
              <Grid.Column>
                <Field
                  name={FieldEnum.SortBy}
                  component={Radio}
                  label={'Actual Date/Time'}
                  myValue="2"
                />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column
                computer={constants.COLUMN_RESPONSIVE_WIDTH_COMPUTER}
                widescreen={constants.COLUMN_RESPONSIVE_WIDTH_WIDESCREEN}
                largeScreen={constants.COLUMN_RESPONSIVE_WIDTH_LARGESCREEN}
              >
                <ReactTable
                  manual
                  minRows={
                    data.Result && data.Result.length > 0
                      ? data.Result.length
                      : 5
                  }
                  defaultPageSize={5}
                  data={data.Result ? data.Result : []}
                  loading={gridLoading}
                  onFetchData={this.fetchData}
                  multiSort={false}
                  showPageSizeOptions={false}
                  onFilteredChange={() => {
                    this.setState({ studentId: '' });
                  }}
                  onSortedChange={() => {
                    this.setState({ studentId: '' });
                  }}
                  pages={data.TotalPages}
                  getTrProps={(state, rowInfo, column) => {
                    return {
                      style: {
                        color: this.colorChange(rowInfo),
                      },
                    };
                  }}
                  columns={[
                    {
                      Header: 'Student Id',
                      accessor: 'Id',
                      resizable: true,
                      filterable: true,
                    },
                    {
                      Header: 'Last Name',
                      accessor: 'LastName',
                      resizable: true,
                      filterable: true,
                    },
                    {
                      Header: 'First Name',
                      accessor: 'FirstName',
                      resizable: true,
                      filterable: true,
                    },
                    {
                      Header: 'Select One',
                      accessor: 'IdSeed',
                      resizable: true,
                      sortable: false,
                      Cell: ({ original }) => {
                        return (
                          <div style={{ textAlign: 'center' }}>
                            <Checkbox
                              checked={original.IdSeed === this.state.studentId}
                              onChange={() => {
                                this.toggleStudentCheckbox(original);
                              }}
                            />
                          </div>
                        );
                      },
                    },
                  ]}
                />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </TitledCard>
      </Form>
    );
  }
}

const validate = values => {
  const errors = {};
  if (!values[FieldEnum.PrimarySiteId]) {
    errors[FieldEnum.PrimarySiteId] = 'Site is required';
  }
  return errors;
};

export default reduxForm({
  validate,
  form: TRANSACTION_HISTORY_BY_STUDENT_FORM_NAME,
})(TransactionHistoryByStudent);



// WEBPACK FOOTER //
// ./src/pages/transactionhistory/components/TransactionHistoryByStudentForm.js